import { Offer } from './../../model/offer.model';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationRequestComponent } from '../../../shared/modal/confirmation-request/confirmation-request.component';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { OfferService } from 'src/app/shared/service/offer.service';
import { PageEnums } from 'src/app/shared/enum/page-enums';

@Component({
  selector: 'app-offer-button',
  templateUrl: './offer-button.component.html',
  styleUrls: ['./offer-button.component.scss']
})
export class OfferButtonComponent implements OnInit {
  @Input() actionLogId: number;
  @Input() workerMail: any;
  @Input() projectMail: any;
  @Input() offerPage: string; // ボタンが存在するページ
  @Input() result: any; // 自動マッチングページの提案管理送信済みフラグ(result.matching.is_already_offerd)を変更するために使用
  @Input() offerType: string; // 1:案件確認依頼, 2:人材確認依頼

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private toastrService: ToastrService,
    private offerService: OfferService
  ) {}

  ngOnInit() {}

  // 提案管理に送るモーダル
  openConsider() {
    const params = {
      project_mail_id: this.projectMail.id,
      worker_mail_id: this.workerMail.id,
      offer_side: this.offerType,
      action_log_id: this.actionLogId,
      action_log_type: this.offerPage
    };
    this.offerService.consider(
      params,
      this.projectMail.ai_mail_id,
      this.workerMail.ai_mail_id
    );

    if (this.offerPage === PageEnums.auto) {
      this.result.matching.is_pair_already_offered = true;
    } else if (this.offerPage === PageEnums.worker_detail) {
      this.workerMail.offer.progress_status = 'considering';
      this.projectMail.offer.progress_status = 'considering';
      this.projectMail.is_pair_already_offered = true;
    } else if (this.offerPage === PageEnums.project_detail) {
      this.workerMail.offer.progress_status = 'considering';
      this.projectMail.offer.progress_status = 'considering';
      this.workerMail.is_pair_already_offered = true;
    }
  }
}
